<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div style="width: calc(100vw - 268px); margin-bottom: 32px" class="" [hidden]="loadingCounter > 0">
  <div class="grid nested-grid">
    <div class="col-9" style="padding-bottom: 0!important;">
      <p-accordion class="w-full background-249" [activeIndex]="0">
        <p-accordionTab iconPos="end">
          <ng-template pTemplate="header">
            <div class="grid">
              <div class="col-2">
                <med-icon-aimbulance
                  size="48"
                  mode="square"
                ></med-icon-aimbulance>
              </div>

              <div class="col-10">
                      <span class="white-space-nowrap postavka">
                          Дочірній розподіл від розподілу №{{parentDistribution.orderName}} &nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                <br>
                <div class="flex flex-between gap-3">
                  <div class="h10-text" style="display: inline-flex">Статус:&nbsp; <img [src]="getPathToStatusImg(distribution.status)" width="4" height="16" style="vertical-align: middle;"/>&nbsp; {{getStatus()}}</div>
                  <div class="h10-text" style="display: inline-flex" *ngIf="distributionApproved">Рішення:&nbsp; <img [src]="getPathToStatusImg('active')" width="4" height="16" style="vertical-align: middle;"/>&nbsp;Розподілено</div>
                </div>
              </div>
            </div>
          </ng-template>

          <div class="grid" style="margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 8vh">


            <div class="col-3">
                      <span class="mobile-h10-text">
                          Дата розподілу
                      </span>
              <br>
              <span class="h10-text">
                          {{distribution.orderDate | date: 'dd.MM.yyyy'}}
                      </span>
            </div>
            <div class="col-3">
              <span class="mobile-h10-text">
                          Розподіл виконано
                      </span>
              <br>
              <span class="h10-text">
                          {{distribution.distributionType}}
                      </span>
            </div>
            <div class="col-3">
              <span class="mobile-h10-text">
                          Напрям
                      </span>
              <br>
              <span class="h10-text">
                          Антидепресанти
                      </span>
            </div>
            <div class="col-3">
              <span class="mobile-h10-text">
                          Регіон
                      </span>
              <br>
              <span class="h10-text">
                          Івано-Франківська обл.
                      </span>
            </div>


          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col-3" style="padding-bottom: 0!important;">
      <p-accordion class="w-full background-249" [activeIndex]="0">
        <p-accordionTab iconPos="end">
          <ng-template pTemplate="header">
            <div class="grid">
              <div class="col-6">
                <med-icon-key-large
                  size="48"
                  mode="circle"
                ></med-icon-key-large>
              </div>

              <div class="col-6 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
              </div>
            </div>
          </ng-template>

          <div class="grid" style="padding: 8px; margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 8vh">
            <div class="col-6">
              <span class="mobile-h10-text">
                          ПІБ
                      </span>
              <br>
              <span class="h10-text">
                          {{ signerFullName() }}
                      </span>
            </div>
            <div class="col-6">
              <span class="mobile-h10-text">
                          Дата
                      </span>
              <br>
              <span class="h10-text">
                          {{ signerDate() | date: 'dd.MM.yyyy' }}
                      </span>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>


<div class="table-wrapper" style="height: 100%; margin-bottom: 108px" *ngIf="rows.length">
  <p-table
    #dt
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="rows"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [columns]="tabHeader"
    [reorderableColumns]="true"
    (onColReorder)="saveColumnOrder()">
    <ng-template pTemplate="header">
      <tr>
        <th class="table-header-text" *ngFor="let column of tabHeader" style="min-width: 10em"  [ngStyle]="{'background-color': column.key === '9' ? '#CCD7ED' : 'rgb(249, 249, 249)'}" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'min-width': '5em'}" *ngIf="column.key !== '2' && column.key !== '9' && column.key !== '7' && column.key !== '8'">
              {{ column.label }}&nbsp;

            <div *ngIf="column.key === '5'">
              <med-btn skin="white" (click)="updateRemnants()" [pTooltip]="tooltipContentRemnants" [disabled]="updateRemnantsInProgress" *ngIf="!READONLY">
                <med-icon-refresh size="18" [ngClass]="{'animate--rotate': updateRemnantsInProgress}"></med-icon-refresh>
              </med-btn>
            </div>
            <ng-template #tooltipContentRemnants>
              <div class="flex items-center h10-text">
                Оновити залишки
              </div>
            </ng-template>

            <div *ngIf="column.key === '4'">
              <med-btn skin="white" (click)="updateDistribution100Financed()" [pTooltip]="tooltipContentFinanced" [disabled]="updateDistribution100FinancedInProgress" *ngIf="!READONLY">
                <med-icon-refresh size="18" [ngClass]="{'animate--rotate': updateDistribution100FinancedInProgress}"></med-icon-refresh>
              </med-btn>
            </div>
            <ng-template #tooltipContentFinanced>
              <div class="flex items-center h10-text">
                Оновити 100% потреба профінансовано
              </div>
            </ng-template>

          </div>
          <div style="display: inline-block" class="flex align-items-center no-wrap flex-between" *ngIf="column.key === '2'">
            <div style="margin-right: 3em">
              Кількість
            </div>
            <div style="cursor: pointer">
              <med-icon-chevron-right size="18"></med-icon-chevron-right>
            </div>
          </div>
          <div style="display: inline-block" class="flex align-items-center flex-between" *ngIf="column.key === '7'">
            <div style="margin-right: 3em">
              Автоматичний розподіл, враховуючи залишки
            </div>
            <ng-template #tooltipContent1>
              <div class="flex items-center h10-text">
                Скопіювати значення у фінальний розподіл
              </div>
            </ng-template>
            <div style="cursor: pointer" [pTooltip]="tooltipContent1"  (click)="copyFromAutoToFinal()" *ngIf="distribution.status === 'DRAFT' && !READONLY">
              <med-icon-copy size="18"></med-icon-copy>
            </div>
          </div>
          <div style="display: inline-block" class="flex align-items-center flex-between" *ngIf="column.key === '8'">
            <div style="margin-right: 3em">
              Пропорційний розподіл
            </div>
            <ng-template #tooltipContent2>
              <div class="flex items-center h10-text">
                Скопіювати значення у фінальний розподіл
              </div>
            </ng-template>
            <div style="cursor: pointer" [pTooltip]="tooltipContent2"  *ngIf="distribution.status === 'DRAFT'">
              <med-icon-copy size="18" (click)="copyFromProportionalToFinal()"></med-icon-copy>
            </div>
          </div>
          <div style="display: inline-block" class="flex align-items-center flex-between" *ngIf="column.key === '9'">
            <div style="margin-right: 3em">
              Фінальний розподіл
            </div>
            <div style="cursor: pointer">
              <med-icon-refresh size="18" *ngIf="!READONLY"></med-icon-refresh>
            </div>
          </div>
      </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowRes let-rowIndex="rowIndex" let-columns="columns">
<!--      <ng-container *ngFor="let recipient of rowRes.recipients">-->
      <tr class="table-content-text" *ngFor="let recipient of rowRes.recipients; let i = index">
        <ng-container *ngFor="let col of columns">

        <td class="h10-text black-80"  *ngIf="i === 0 && col.key === '1'" [attr.rowspan]="rowRes.recipients.length">
          {{rowRes.mnnId}}
        </td>
        <td class="h10-text black-80" style="border-right: 1px solid #ebedff" *ngIf="i === 0 && col.key === '2'" [attr.rowspan]="rowRes.recipients.length">
          {{rowRes.quantity}}
        </td>

            <td class="h10-text black-80" *ngIf="col.key === '3'">
              {{recipient.recipientName}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '4'">
              {{recipient.requisition}}
            </td>

            <td class="h10-text black-80" *ngIf="col.key === '5'">
              {{recipient.remnants}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '6'">
              {{recipient.dividedPerYear}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '7'">
              {{recipient.distributedAuto}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '8'">
              {{recipient.distributedProportional}}
            </td>
            <td class="h10-text black-90" style="background: #F5F9FF!important;" *ngIf="col.key === '9'">
              <med-input  [size]="'small'"  type="number" *ngIf="distribution.status === 'DRAFT' || distribution.status === 'AWAITING_DOZ_DISTRIBUTION'"
                          [state]="inputWithDigitalFraction(recipient.distributedFinally) ?'error': ''"
                          [(ngModel)]="recipient.distributedFinally"></med-input>
              <span *ngIf="distribution.status === 'COMPLETED'">
                {{recipient.distributedFinally}}
              </span>
            </td>
            <td class="h10-text" *ngIf="col.key === '10'">
              <med-icon-delete size="16"></med-icon-delete>
            </td>
          </ng-container>
<!--      </ng-container>-->
      </tr>
    </ng-template>
  </p-table>
</div>



<div
  [style.width]="'calc(100vw - 0px)'"
  [style.height]="'60px'"
  class="med-layout__footer"
>
  <div class="med-layout__footer-content">
    <div class="flex flex-center flex-between">
      <div class="flex flex-center">

        <med-btn class="mr-1" (click)="goToDistributions()">
          <med-icon-reply size="18"></med-icon-reply>
          &nbsp;
          <span>До реєстру розподілу</span>
        </med-btn>
        <med-btn class="mr-1" (click)="goToSeries()" *ngIf="!READONLY">
          <med-icon-plus size="16"></med-icon-plus>
          &nbsp;
          <span>Серії/Каталожні номери</span>
        </med-btn>

        <med-btn class="mr-1" (click)="openAttachmentsModal()">
          <span>Вкладення</span>
          &nbsp;
          {{ attachments.content.length }}
        </med-btn>

        <med-btn class="mr-1" (click)="reviewModal = true">
          <span>Переглад</span>
          &nbsp;
          <med-icon-visibility size="18"></med-icon-visibility>
        </med-btn>

        <med-btn class="mr-1" (click)="alert('under development')">
          <med-icon-download size="18"></med-icon-download>
        </med-btn>

      </div>
      <div class="flex flex-center">
        <med-btn class="ml-1" *ngIf="distribution.status === 'DRAFT'" (click)="archive()">
          <med-icon-archive size="16"></med-icon-archive>
          &nbsp;
          <span>Архівувати</span>
        </med-btn>

        <med-btn skin="red" class="ml-1" (click)="sendToReworking()" *ngIf="distribution.status === 'AWAITING_DOZ_DISTRIBUTION'">
          <med-icon-arrow-circle-left size="18"></med-icon-arrow-circle-left>
          &nbsp;
          <span>Відправити на доопрацювання</span>
        </med-btn>

        <med-btn skin="yellow" class="ml-1" (click)="subDistributionAgreementModal = true" *ngIf="distribution.status === 'DRAFT'">
          <span>Перейти до погодження</span>
          &nbsp;
          <med-icon-arrow-right size="18"></med-icon-arrow-right>
        </med-btn>

        <med-btn skin="yellow" class="ml-1" (click)="invokeSignModal()" *ngIf="distribution.status === 'AWAITING_DOZ_DISTRIBUTION'">
          <span>Підтвердити розподіл</span>
          &nbsp;
          <med-icon-check size="18"></med-icon-check>
        </med-btn>
      </div>
    </div>
  </div>
</div>


<!--<med-modal-->
<!--  [(visible)]="attachmentsModal"-->
<!--&gt;-->
<!--  <div>-->
<!--    <div class="flex flex-center mb-4">-->
<!--      <med-icon-docs-->
<!--        size="36"-->
<!--        mode="square"-->
<!--      ></med-icon-docs>-->

<!--      <h6 class="text extra-large ml-2 mb-0 mt-0">-->
<!--        Вкладення-->
<!--      </h6>-->
<!--    </div>-->

<!--    <div class="table-wrapper" style="height: unset">-->
<!--      <p-table-->
<!--        #dt-->
<!--        styleClass="p-datatable-sm"-->
<!--        [scrollable]="true"-->
<!--        scrollHeight="flex"-->
<!--        [value]="[1, 2]"-->
<!--        [customSort]="true"-->
<!--        [lazy]="true"-->
<!--        [resizableColumns]="true">-->

<!--        <ng-template pTemplate="header">-->
<!--          <tr>-->
<!--            <th class="mobile-h10-text" style="background-color: rgb(249, 249, 249)!important; min-width: 8.5em">-->
<!--              <div style="display: inline-block" class="flex align-items-center">-->
<!--                Тип-->
<!--              </div>-->
<!--            </th>-->
<!--            <th class="mobile-h10-text" style="background-color: rgb(249, 249, 249)!important; min-width: 3em">-->
<!--              <div style="display: inline-block" class="flex align-items-center">-->
<!--                Файл-->
<!--              </div>-->
<!--            </th>-->
<!--            <th class="mobile-h10-text" style="background-color: rgb(249, 249, 249)!important; min-width: 3em">-->
<!--              <div style="display: inline-block" class="flex align-items-center">-->
<!--                Номер-->
<!--              </div>-->
<!--            </th>-->
<!--            <th class="mobile-h10-text" style="background-color: rgb(249, 249, 249)!important; min-width: 3em">-->
<!--              <div style="display: inline-block" class="flex align-items-center">-->
<!--                Дата-->
<!--              </div>-->
<!--            </th>-->
<!--            <th class="mobile-h10-text" style="background-color: rgb(249, 249, 249)!important; min-width: 3em">-->
<!--              <div style="display: inline-block" class="flex align-items-center">-->
<!--                Завантаження здійснив-->
<!--              </div>-->
<!--            </th>-->
<!--            <th class="mobile-h10-text" style="background-color: rgb(249, 249, 249)!important; min-width: 3em">-->
<!--              &nbsp;-->
<!--            </th>-->
<!--          </tr>-->
<!--        </ng-template>-->

<!--        <ng-template pTemplate="body" let-row>-->
<!--          <tr class="table-content-text">-->
<!--            <td class="black-80 h9-text">-->
<!--              Наказ-->
<!--            </td>-->
<!--            <td class="black-60 h10-text">-->
<!--              <med-upload-file-->
<!--                [hideClearBtn]="true"-->
<!--                size="small"-->
<!--                accept="image/*"-->
<!--                placeholder="Виберіть файл"-->
<!--              ></med-upload-file>-->
<!--            </td>-->
<!--            <td class="black-80 h9-text">-->
<!--              EM-2890-->
<!--            </td>-->
<!--            <td class="black-80 h9-text">-->
<!--              29.10.2024-->
<!--            </td>-->

<!--            <td class="black-80 h9-text">-->
<!--              Вінницький ДОЗ-->
<!--            </td>-->
<!--            <td>-->
<!--              <med-btn size="small" skin="white">-->
<!--                <med-icon-download size="16"></med-icon-download>-->
<!--              </med-btn>-->
<!--            </td>-->
<!--          </tr>-->
<!--        </ng-template>-->

<!--      </p-table>-->
<!--    </div>-->
<!--  </div>-->
<!--</med-modal>-->

<!--<med-modal-->
<!--  [(visible)]="reviewModal">-->
<!--  <div style="width: 90vw; height: 90vh">-->
<!--    <div class="h7-heading mb-2">-->
<!--      Перегляд розподілу-->
<!--    </div>-->

<!--    <div class="table-wrapper" style="height: 80vh">-->
<!--      <p-table-->
<!--        #dt-->
<!--        styleClass="p-datatable-sm"-->
<!--        [scrollable]="true"-->
<!--        scrollHeight="flex"-->
<!--        [value]="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]"-->
<!--        [customSort]="true"-->
<!--        [lazy]="true"-->
<!--        [resizableColumns]="true">-->

<!--        <ng-template pTemplate="header">-->
<!--          <tr>-->
<!--            <th rowspan="2" class="h10-text">-->
<!--              Адміністративно-територіальні одиниці/Заклад охорони здоров’я-->
<!--            </th>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <th colspan="3" class="h10-text">-->
<!--              Набір реагентів cobasio TagScreen для мультиплексної детекції (МРХ), в2.0-->
<!--              (Тест для внявлення РНК ВІТ-1, ВІЛ-2, РНК вірусу гепатиту С, ДНК вірусу гепатиту В на системі cobas s 201, 96тестів, cobas® TagScreen MPX Тест, версія 2, 96 тестів, або еквівалент)-->
<!--              Виробник: Рош Молекулар Системс Інк., США-->
<!--              Ціна за упаковку - 90 047,00 грн-->
<!--              (mnn id: 16422)-->
<!--            </th>-->
<!--            <th colspan="3" class="h10-text">-->
<!--              Контрольний набір реагентів cobas® TaqScreen для мультиплексної детекції (МРХ), версія 2.0-->
<!--              (Набір контролів для тесту Т- SCRN MPX v 2.0, 6 наборів, cobas® TaqScreen MPX контрольний набір, версія 2, 3 по 6 флаконів по 1,6 мл, або еквівалент)-->
<!--              Виробник: Рош Молекулар Системс Інк., США-->
<!--              Ціна за упаковку - 90 047,00 грн-->
<!--              (mnn id: 16423)-->
<!--            </th>-->
<!--            <th colspan="3" class="h10-text">-->
<!--              100% Пристрій для підготовки зразку-->
<!--              (Пристрій для підготовки зразка/Specific sample processing unit (SPU), cobas®, 12 по 24 штуки, або еквівалент)-->
<!--              Виробник: Рош Молекулар Системс Інк., США-->
<!--              Ціна за упаковку - 6 346,00 грн-->
<!--              (mnn id: 16424)-->
<!--            </th>-->
<!--            <th colspan="3" class="h10-text">-->
<!--              Вхідні S - трубки 12 х 24 шт-->
<!--              (Вхідні S-трубки 12 по 24 штуки + Barcode Flips/S-Tube Input, cobas®, або еквівалент)-->
<!--              Виробник: Рош Молекулар Системс Інк., США-->
<!--              Ціна за упаковку - 6 140,00 грн-->
<!--              (mnn id: 16425)-->
<!--            </th>-->
<!--          </tr>-->

<!--          <tr>-->
<!--            <th class="h10-text">-->

<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              К-сть одиниць-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              К-сть упаковок-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              В-сть, грн-->
<!--            </th>-->

<!--            <th class="h10-text">-->
<!--              К-сть одиниць-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              К-сть упаковок-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              В-сть, грн-->
<!--            </th>-->

<!--            <th class="h10-text">-->
<!--              К-сть одиниць-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              К-сть упаковок-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              В-сть, грн-->
<!--            </th>-->

<!--            <th class="h10-text">-->
<!--              К-сть одиниць-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              К-сть упаковок-->
<!--            </th>-->
<!--            <th class="h10-text">-->
<!--              В-сть, грн-->
<!--            </th>-->


<!--          </tr>-->

<!--        </ng-template>-->

<!--        <ng-template pTemplate="body" let-row>-->
<!--          <tr class="table-content-text">-->
<!--            <td class="h10-text black-80">-->
<!--              Вінницька обл.-->
<!--            </td>-->

<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-60">-->
<!--              800000.00-->
<!--            </td>-->

<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-60">-->
<!--              800000.00-->
<!--            </td>-->

<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-60">-->
<!--              800000.00-->
<!--            </td>-->

<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-80">-->
<!--              3-->
<!--            </td>-->
<!--            <td class="h10-text black-60">-->
<!--              800000.00-->
<!--            </td>-->

<!--          </tr>-->
<!--        </ng-template>-->

<!--      </p-table>-->
<!--    </div>-->

<!--  </div>-->
<!--</med-modal>-->

<med-modal [(visible)]="refuseModal" [closeableOutside]="false">
  <!--  <div style="padding: 80px 148px">-->
  <div style="padding: 5px 10px">

    <app-loader *ngIf="refuseRequestCounter > 0" [ngStyle]="{'width': '480px', 'display': 'flex'}"></app-loader>


    <div style="width: 480px"  *ngIf="refuseRequestCounter === 0 && !refused">
      <div class="flex flex-center justify-content-center">
        <div><img src="assets/images/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Відправити на доопрацювання
      </div>

      <div style="margin-top: 24px">
        <span class="h10-text black-60">
          Коментар
        </span>
        <span class="h10-text black-30">
          0/1000
        </span>
      </div>

      <div>
        <med-textarea height="88px" [state]="commentStatus" [(ngModel)]="comment">

        </med-textarea>
      </div>

<!--      <div style="margin-top: 24px">-->
<!--        <med-card>-->
<!--          <div class="flex flex-between flex-center">-->
<!--            <med-radio-group position="horizontal" [options]="options" [value]="value"></med-radio-group>-->
<!--            &lt;!&ndash;            <med-icon-close></med-icon-close>&ndash;&gt;-->
<!--          </div>-->
<!--          <div style="margin-top: 24px" class="flex flex-between flex-center">-->
<!--            <div style="width: 50%">-->
<!--              <med-input label="Номер документу"></med-input>-->
<!--            </div>-->
<!--            <div style="width: 50%; margin-left: 10px">-->
<!--              <med-datepicker label="Дата"></med-datepicker>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div style="margin-top: 24px">-->
<!--            <div style="width: 100%">-->
<!--              <med-upload-file></med-upload-file>-->
<!--            </div>-->
<!--          </div>-->
<!--        </med-card>-->
<!--      </div>-->

<!--      <div style="margin-top: 16px" class="flex flex-center justify-content-center">-->
<!--        <med-btn [disabled]="true">-->
<!--          <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>-->
<!--          Додати ще вкладення-->
<!--        </med-btn>-->
<!--      </div>-->

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="refuseDistribution()">
          Відправити
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 12px">
        <med-btn skin="gray">
          Скасувати
        </med-btn>
      </div>

    </div>

    <div style="width: 480px" *ngIf="refuseRequestCounter === 0 && refused">

      <div class="flex flex-center justify-content-center">
        <div><img src="assets/images/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Відправити на доопрацювання
      </div>

      <div style="padding-top: 24px">
        <med-card>
          <div class="grid" style="padding: 24px">
            <div class="col-2">
              <med-icon-key-large
                size="48"
                mode="circle"
              ></med-icon-key-large>
            </div>

            <div class="col-10 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
            </div>
          </div>
          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              П.І.Б
            </div>
            <div class="col-6 mobile-h10-text black-60">
              Час підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              Крушельницька М.
            </div>
            <div class="col-6 h10-text black-80">
              10.12.2023 17:25
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Оргацізація
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              Департамент охорони здоров`я
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Серійний номер підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              А0000123123120000000000123100001
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              ЄДРПОУ організації
            </div>
            <div class="col-6 mobile-h10-text black-60">
              ДРФО
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              12345678
            </div>
            <div class="col-6 h10-text black-80">
              12345678
            </div>
          </div>
        </med-card>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="refuseDone()">
          Готово
        </med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal [(visible)]="signModal" [closeableOutside]="false">
  <!--  <div style="padding: 80px 148px">-->
  <div style="padding: 5px 10px">

    <app-loader *ngIf="signRequestCounter > 0" [ngStyle]="{'width': '480px', 'display': 'flex'}"></app-loader>

    <div style="width: 480px" *ngIf="signRequestCounter === 0 && !signed">
      <div class="flex flex-center justify-content-center">
        <div><img src="assets/icons/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Підтвердити розподіл
      </div>

      <div style="margin-top: 24px">
        <med-card>
          <div class="flex flex-between flex-center">
            <med-radio-group position="horizontal" [options]="options" [value]="value"></med-radio-group>
            <!--            <med-icon-close></med-icon-close>-->
          </div>
          <div style="margin-top: 24px" class="flex flex-between flex-center">
            <div style="width: 50%">
              <med-input label="Номер документу"></med-input>
            </div>
            <div style="width: 50%; margin-left: 10px">
              <med-datepicker label="Дата"></med-datepicker>
            </div>
          </div>
          <div style="margin-top: 24px">
            <div style="width: 100%">
              <med-upload-file></med-upload-file>
            </div>
          </div>
        </med-card>
      </div>

      <div style="margin-top: 16px" class="flex flex-center justify-content-center">
        <med-btn [disabled]="true">
          <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>
          Додати ще вкладення
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="invokeSignModal()">
          Підписати
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 12px">
        <med-btn skin="gray">
          Скасувати
        </med-btn>
      </div>

    </div>

    <div style="width: 480px" *ngIf="signRequestCounter === 0 && signed">

      <div class="flex flex-center justify-content-center">
        <div><img src="assets/icons/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Підтвердити розподіл
      </div>

      <div style="margin-top: 24px">
        <med-card *ngIf="decryptedObject && decryptedObject.signerInfo">
          <div class="grid" style="padding: 24px">
            <div class="col-2">
              <med-icon-key-large
                size="48"
                mode="circle"
              ></med-icon-key-large>
            </div>

            <div class="col-10 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
            </div>
          </div>
          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              П.І.Б
            </div>
            <div class="col-6 mobile-h10-text black-60">
              Час підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjFullName}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signedAt | date: 'dd.MM.yyyy hh:mm'}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Оргацізація
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.issuerCN}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Серійний номер підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.serial}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              ЄДРПОУ організації
            </div>
            <div class="col-6 mobile-h10-text black-60">
              ДРФО
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjEDRPOUCode}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjDRFOCode}}
            </div>
          </div>
        </med-card>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="signDone()">
          Готово
        </med-btn>
      </div>
    </div>
  </div>
</med-modal>

<!--<med-modal-->
<!--  [(visible)]="subDistributionAgreementModal"-->
<!--  class="no-padding"-->
<!--&gt;-->
<!--  <div style="width: 383px; height: 316px; padding: 32px">-->
<!--    <div class="flex justify-content-center">-->
<!--      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>-->
<!--    </div>-->
<!--    <div class="text-h6-heading" style="margin-top: 12px">-->
<!--      Ви впевнені, що бажаєте створити дочірній розподіл?-->
<!--    </div>-->
<!--    <div style="margin-top: 32px">-->
<!--      <div>-->
<!--        <med-btn (click)="createSubDistribution()" class="width-100">Підтвердити</med-btn>-->
<!--      </div>-->
<!--      <div class="mt-1">-->
<!--        <med-btn skin="gray" (click)="subDistributionAgreementModal = false" class="width-100">Скасувати</med-btn>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</med-modal>-->

<med-modal
  [(visible)]="medSignModal"
  class="no-padding"
>
  <div style="width: 1000px; height: 600px; padding: 32px">
    <med-sign *ngIf="medSignModal"
      [data]="JSON.stringify(dataToSign)"
      (sign)="onSign($event)"
    ></med-sign>
  </div>
</med-modal>

<med-modal
  [(visible)]="subDistributionAgreementModal"
  class="no-padding"
>
  <div style="width: 383px; height: 316px; padding: 32px">
    <div class="flex justify-content-center">
      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
    </div>
    <div class="text-h6-heading" style="margin-top: 12px">
      Ви впевнені, що бажаєте відправити дочірній розподіл на погодження в ДОЗ?
    </div>
    <div style="margin-top: 32px">
      <div>
        <med-btn (click)="agreeSubDistribution()" class="width-100">Підтвердити</med-btn>
      </div>
      <div class="mt-1">
        <med-btn skin="gray" (click)="subDistributionAgreementModal = false" class="width-100">Скасувати</med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal
  [(visible)]="attachmentsModal"
>
  <div>
    <div class="flex flex-center mb-4">
      <med-icon-docs
        size="36"
        mode="square"
      ></med-icon-docs>

      <h6 class="text extra-large ml-2 mb-0 mt-0">
        Вкладення
      </h6>
    </div>

    <app-loader *ngIf="attachments.isLoading"></app-loader>
    <div class="table-wrapper" style="height: unset" *ngIf="!attachments.isLoading">
      <p-table
        #dt
        styleClass="p-datatable-sm"
        [scrollable]="true"
        scrollHeight="flex"
        [value]="attachments.content"
        [customSort]="true"
        [lazy]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [columns]="attachmentsTabHeader"
        [reorderableColumns]="true"
        (onColReorder)="saveColumnOrderCustom('attachemntsDozColumnOrder', attachmentsTabHeader)">

        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let column of attachmentsTabHeader">
              <th class="mobile-h10-text table-header-bg-grey" pReorderableColumn pResizableColumn>
                <div style="display: inline-block" class="flex align-items-center">
                  {{ column.label }}&nbsp;
                </div>
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row  let-columns="columns">
          <tr class="table-content-text">
            <ng-container *ngFor="let col of columns">
              <td class="black-80 h9-text" *ngIf="col.key === '1'">
                {{ row.type }}
              </td>
              <td class="black-60 h10-text" *ngIf="col.key === '2'">
                {{ row.fileName }}
              </td>
              <td class="black-80 h9-text" *ngIf="col.key === '3'">
                {{ row.fileNumber }}
              </td>
              <td class="black-80 h9-text" *ngIf="col.key === '4'">
                {{ row.selectedDate | date: 'dd.MM.yyyy' }}
              </td>

              <td class="black-80 h9-text" *ngIf="col.key === '5'">
                {{row.owner}}
              </td>
              <td *ngIf="col.key === '6'">
                <med-btn size="small" skin="white">
                  <med-icon-download size="16" (click)="downloadFile(row)"></med-icon-download>
                </med-btn>
              </td>
            </ng-container>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>
</med-modal>
